import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-dashboard-report',
  templateUrl: './help-dashboard-report.component.html',
  styleUrls: ['./help-dashboard-report.component.scss']
})
export class HelpDashboardReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
